import { Flex } from "@chakra-ui/react";
import { HeaderFlagBox } from "../HeaderFlagBox";
import { HeaderLogo } from "../HeaderLogo";
import type { HeaderMobileProps } from "../types";
import { HeaderLinks } from "./HeaderLinks";
import { SideMenu } from "./SideMenu";

export const HeaderMobile = ({
  headerLinks,
  pageLanguage,
  headerLogo,
  headerFlagBoxHideForStories,
  headerActionButton,
  sideMenuContent,
}: HeaderMobileProps) => (
  <Flex align="center">
    <HeaderLogo language={pageLanguage} headerLogo={headerLogo} />
    <HeaderFlagBox
      headerFlagBoxHideForStories={headerFlagBoxHideForStories}
      testId="header-flag-box-language-switcher"
    />
    {sideMenuContent && <SideMenu pageHeading={sideMenuContent} />}
    <HeaderLinks headerLinks={headerLinks} headerActionButton={headerActionButton} />
  </Flex>
);
